import { render, staticRenderFns } from "./SapDeliveryLogisticsRecord.vue?vue&type=template&id=7d47f258&scoped=true"
import script from "./SapDeliveryLogisticsRecord.vue?vue&type=script&lang=js"
export * from "./SapDeliveryLogisticsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d47f258",
  null
  
)

export default component.exports